import React from 'react';
import { Box, Typography, Button, Container } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundColor: '#FAFBFD',
      }}
    >
      <Container maxWidth="sm" sx={{ textAlign: 'center' }}>
        <ErrorOutlineIcon sx={{ fontSize: 100, color: '#E94C4C', mb: 2 }} />
        <Typography variant="h2" component="h1" gutterBottom sx={{ fontWeight: 'bold', color: '#333' }}>
          404
        </Typography>
        <Typography variant="h5" component="h2" gutterBottom sx={{ color: '#666', mb: 4 }}>
          Oops! The page you're looking for doesn't exist.
        </Typography>
        <Button
          variant="contained"
          size="large"
          onClick={() => navigate('/')}
          sx={{
            backgroundColor: '#8A5918',
            color: '#fff',
            '&:hover': {
              backgroundColor: '#6d4612',
            },
            borderRadius: '8px',
            px: 4,
            py: 1.5,
            textTransform: 'none',
            fontSize: '16px',
          }}
        >
          Go Back Home
        </Button>
      </Container>
    </Box>
  );
};

export default NotFound;
